import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompanyInfoForm from '../../../components/forms/CompanyInfoForm';
import { CompanyInfoClient, CompanyInfoDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';

const CompanyInfoCreate: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const apiClient = new CompanyInfoClient(API_BASE_URL);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Company Info', href: '/admin/companyinfo' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompanyInfoDTO) => {
    setIsSubmitting(true);
    try {
      await apiClient.createCompanyInfo(data);
      navigate('/admin/companyinfo');
    } catch (error) {
      console.error('Error creating company info:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      title="Create Company Info"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        <CompanyInfoForm
          initialValues={{} as CompanyInfoDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/companyinfo')}
        />
      </Card>
    </AdminLayout>
  );
};

export default CompanyInfoCreate;
